<template src="./list.html"></template>

<script>

import TopService from 'Services/TopService';

export default {
  data() {
    return {
      top: {},
      i18n: 2,
    };
  },

  created() {
    this.list();
  },

  methods: {
    convertHTML(value) {
      if (value) {
        if (value.length < 1000) {
          return `${value.replace(/(<([^>]+)>)/g, '')}`;
        }
        return `${value.replace(/(<([^>]+)>)/g, '').substring(0, 1000)}...`;
      }

      return '';
    },
    list() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }

      const params = {
        i18n: this.i18n,
      };

      TopService.listInternShip(params)
        .then((response) => {
          this.top = response.data;
        })
        .catch(() => {
        });
    },
  },
};
</script>
<style scoped>
pre {
    text-align: justify;
    white-space: pre-line;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 10;
    display: -webkit-box;
    -webkit-box-orient: vertical;
};
.team_main_contant2 {
    margin-top: 40px;
    margin-bottom: 20px;
    border: 1px solid #d6e0e2;
    text-align: center;
}
</style>
